<div class="dialog-header">
  <div class="dialog-title">Installa Check <img src="../../../../assets/img/icons/logos/check-logo.svg" /></div>
  <img src="/assets/img/icons/xmark.svg" class="btn-close-img" mat-dialog-close/>
</div>

<mat-dialog-content class="mat-body">
  L'applicazione di Check è ora {{alertMessage}}.
  <br />
  Vuoi installarla?
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close>No, continua sul browser</button>
  <button *ngIf="platform == PlatformEnum.web" color="primary" mat-flat-button [mat-dialog-close]="true">Installa</button>
  <button *ngIf="platform == PlatformEnum.android || platform == PlatformEnum.ios"
          color="primary" mat-flat-button (click)="window.open(platform == PlatformEnum.ios ? environment.APP_STORE_PATH :
          environment.GOOGLE_PLAY_PATH, '_blank')">Installa</button>
</mat-dialog-actions>
